import React from "react";
import { motion } from "framer-motion";
import { fadeUp } from "../../lib/motion";

const outcomes = [
  "Clear systems and structure",
  "Professional client processes",
  "Seamless onboarding and communication",
  "Organised backend and workflows",
  "The confidence to grow properly",
];

export default function Solution() {
  return (
    <section data-testid="solution-section" className="py-28 sm:py-40">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        <motion.div {...fadeUp} className="lg:col-span-5">
          <p className="overline mb-6">— What You Get</p>
          <h2 className="font-serif-display font-medium text-4xl sm:text-5xl tracking-tight text-[color:var(--charcoal)] leading-[1.08]">
            Your business will
            <br />
            <span className="italic">operate with</span>:
          </h2>
          <p className="mt-10 text-lg text-[color:var(--text-secondary)] leading-relaxed font-light max-w-md">
            Everything is built for you — intentionally and properly.
          </p>
        </motion.div>
        <motion.ul
          {...fadeUp}
          className="lg:col-span-7 border-l border-[color:var(--border-light)] pl-10"
          data-testid="solution-list"
        >
          {outcomes.map((o, i) => (
            <li
              key={o}
              className="flex items-baseline gap-6 py-6 border-b border-[color:var(--border-light)] last:border-0"
            >
              <span className="font-serif-display italic text-[color:var(--gold)] text-lg">
                {String(i + 1).padStart(2, "0")}
              </span>
              <p className="font-serif-display text-xl sm:text-2xl font-medium text-[color:var(--charcoal)] leading-snug">
                {o}
              </p>
            </li>
          ))}
        </motion.ul>
      </div>
    </section>
  );
}
